import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const ScrollSection = ({
  children,
  delay = 0,
  direction = "up" // up, down, left, right, fade
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false, // Animation triggers every time it comes into view
    margin: "-100px" // Trigger slightly before entering viewport
  });

  const directionVariants = {
    up: { y: 100, opacity: 0 },
    down: { y: -100, opacity: 0 },
    left: { x: 100, opacity: 0 },
    right: { x: -100, opacity: 0 },
    fade: { opacity: 0 }
  };

  const variants = {
    hidden: directionVariants[direction],
    visible: {
      x: 0,
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: delay,
        ease: [0.17, 0.55, 0.55, 1]
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default ScrollSection;
